import isEmpty from 'lodash/isEmpty';

import { APPLY_PRESET } from '@gogame/screens';

import { mapPresetToState, seriesSchema, hiddenSchema } from '../schemas';
import { kpiReducer, CLEAR, SET_PERIOD } from './kpiReducer';
import { DELETE_SERIES, ADD_SERIES, SET_SERIES } from './seriesReducer';

export const APPLY = 'APPLY';
export const DELETE_LAST_SERIES = 'DELETE_LAST_SERIES';

export function kpiTemporaryStateReducer(state = {}, _action) {
  let action = { ..._action };
  switch (action.type) {
    case APPLY:
      const newSeries = state.temporary?.series.map(({ dirty: _, ...s }) => s);
      if (isEmpty(newSeries)) {
        return {
          ...state,
          hidden: hiddenSchema.default(),
          series: seriesSchema.default(),
        };
      }
      return {
        ...state,
        ...state.temporary,
        series: newSeries,
        temporary: null,
      };

    case APPLY_PRESET:
      if (action.payload) {
        const { id, data } = action.payload;
        const { applyPresetData } = action.meta;

        // if applyPresetData is 'false', it is new preset and it's data equal to current state
        return {
          ...(applyPresetData ? mapPresetToState(data) : state),
          presetId: id,
          temporary: null,
        };
      }

      return {
        ...state,
        presetId: undefined,
        temporary: null,
      };
    case DELETE_SERIES:
    case SET_SERIES:
    case ADD_SERIES:
    case CLEAR:
    case SET_PERIOD:
      const temporaryState = ensureTemporaryState(state);
      return {
        ...state,
        temporary: kpiReducer(temporaryState, action),
      };

    case DELETE_LAST_SERIES: {
      // we should apply last series without applying
      action = {
        ...action,
        type: DELETE_SERIES,
      };
    }

    default:
      return kpiReducer(
        {
          ...state,
          ...(state.temporary
            ? { temporary: kpiReducer(state.temporary, action) }
            : null),
        },
        action
      );
  }
}

export function ensureTemporaryState(state) {
  return state?.temporary ? state.temporary : { ...state };
}
